import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Del from "../../Assets/Images/Souvenir/Icons/delete.png";
import Icon from "../../Assets/Images/Souvenir/Icons/auction.png";

import "./AuctionSignature.css";
import axios from "axios";
import { Markup } from "interweave";
import swal from "sweetalert";
import RightSideAuction from "../../components/StarShowcase/Auction/Content/RightSideAuction/RightSideAuction";

import Navigation from "../../components/Layouts/Header/Navigation";
import PaymentModal from "../../components/Modal/PaymentModal/PaymentModal";
import { serverInfo } from "../../App";
import MyVerticallyCenteredModal from "../../components/RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import { LocationContext } from "../../CustomHelper/Helper";
const AuctionSignature = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  const history = useHistory();
  const params = useParams();
  const [auctionInfo, setAuctionInfo] = useState([]);
  const [sideData, setSideData] = useState([]);
  // const [userInfo , setUserInfo] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const [maxBid, setMaxBid] = useState([]);
  const [successShow, setSuccessShow] = useState(false);

  useEffect(() => {
    axios.get(`/api/user/auctionApply/auction/${params.id}`).then((res) => {
      if (res.data.status === 200) {
        setAuctionInfo(res.data.auctionApply);
        // setUserInfo(res.data.userInfo);
      }
    });
    axios.get(`/api/user/getStarAuctionProduct/${params.id}`).then((res) => {
      if (res.data.status === 200) {
        setSideData(res.data.product);
        // setUserInfo(res.data.userInfo);
      }
    });
    axios.get(`/api/user/maxbid/auction/${params.id}`).then((res) => {
      if (res.data.status === 200) {
        setMaxBid(res.data.maxBid);
        // setUserInfo(res.data.userInfo);
      }
    });
  }, []);

  const dismiss = () => {
    history.push(`/auction/${params.id}`);
  };

  const [cardInput, setCardInput] = useState({
    name: "",
    phone: "",
    card_number: "",
    expiry_date: "",
    ccv: "",
    error_list: [],
  });

  const handleCardInput = (e) => {
    e.persist();
    setCardInput({ ...cardInput, [e.target.name]: e.target.value });
  };

  const cardInfoSubmit = (e) => {
    e.preventDefault();
    const data = {
      name: cardInput.name,
      bidding_id: maxBid?.id,
      phone: cardInput.phone,
      card_number: cardInput.card_number,
      expiry_date: cardInput.expiry_date,
      ccv: cardInput.ccv,
    };

    // const fData = new FormData();

    // fData.append('name', cardInput.name);
    // fData.append('phone_number', cardInput.phone_number);
    // fData.append('card_number', cardInput.card_number);
    // fData.append('expiry_date', cardInput.expiry_date);
    // fData.append('ccv', cardInput.ccv);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/user/aquired/auction`, data).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push(`/auction-applied/${auctionInfo?.auction?.id}`);
        } else {
          if (res.data.status === 402) {
            setErrorList(res.data.errors);
          }
        }
      });
    });
  };

  return (
    <div>
      <Navigation />
      <div className="container">
        <div>
          <img
            src={imageCdnUrl + auctionInfo?.auction?.banner}
            className="img-fluid w-100"
            alt=""
            style={{ height: "500px" }}
          />
          <div className="row">
            <div className="col-md-7">
              <div className="row">
                <div className="col-md-9">
                  <div className="my-4">
                    <div className="d-flex flex-start">
                      <h1 className="fw-bolder text-white">
                        {auctionInfo?.auction?.title}
                      </h1>
                    </div>

                    <p className="text-white">
                      {showMore ? (
                        <Markup content={auctionInfo?.auction?.details} />
                      ) : (
                        <Markup
                          content={auctionInfo?.auction?.details.substring(
                            0,
                            50
                          )}
                        />
                      )}
                      <button
                        className="btn text-white"
                        onClick={() => setShowMore(!showMore)}
                      >
                        {showMore ? "Show less" : "Show more"}
                      </button>
                    </p>
                  </div>

                  <button
                    className="btn btn-warning"
                    onClick={() => setSuccessShow(true)}
                  >
                    Make Payment{" "}
                  </button>

                  <MyVerticallyCenteredModal
                    show={successShow}
                    onHide={() => setSuccessShow(false)}
                    event_id={params?.id}
                    fee={paymentCount(maxBid?.amount)}
                    baseFee={maxBid?.amount}
                    event_type="auction"
                    redirectTo="activities"
                  />

                  {/*                   
                  <form className="me-5">
                    <div className="acquireForm p-3">
                      <h5 className="text-white fw-bold mb-3">
                        Acquire application
                      </h5>

                      <div className="acquireText"></div>

                      <div>
                        <div className="my-2">
                          <label htmlFor="">
                            <big className="text-white">Name</big>
                          </label>
                          <input
                            className="form-control input-gray"
                            type="text"
                            name="name"
                            value={cardInput.name}
                            onChange={handleCardInput}
                          />
                          <span className="text-danger">{errorList.name}</span>
                        </div>

                        <div className="my-2">
                          <label htmlFor="">
                            <big className="text-white">Phone</big>
                          </label>
                          <input
                            className="form-control input-gray"
                            type="number"
                            name="phone"
                            value={cardInput.phone}
                            onChange={handleCardInput}
                          />
                          <span className="text-danger">{errorList.phone}</span>
                        </div>

                        <div className="selectOption my-2">
                          <label htmlFor="">
                            <big className="text-white">Payment Method</big>
                          </label>
                          <div className="select-wrapper">
                            <select className="select">
                              <option value="value1">bKash</option>
                              <option value="value1">Visa</option>
                              <option value="value2">Banana</option>
                              <option value="value3">Cherries</option>
                            </select>
                          </div>
                        </div>

                        <div className="my-2">
                          <label htmlFor="">
                            <big className="text-white">Card number</big>
                          </label>
                          <input
                            className="form-control input-gray"
                            type="number"
                            name="card_number"
                            onChange={handleCardInput}
                            value={cardInput.card_number}
                          />
                          <span className="text-danger">
                            {errorList.card_number}
                          </span>
                        </div>

                        <div className="row my-2">
                          <div className="col-md-5">
                            <label htmlFor="">
                              <big className="text-white">CCV</big>
                            </label>
                            <input
                              className="form-control input-gray"
                              type="number"
                              name="ccv"
                              onChange={handleCardInput}
                              value={cardInput.ccv}
                            />
                            <span className="text-danger">{errorList.ccv}</span>
                          </div>
                          <div className="col-md-7">
                            <label htmlFor="">
                              <big className="text-white">Expiry date</big>
                            </label>
                            <input
                              className="form-control input-gray"
                              type="text"
                              name="expiry_date"
                              onChange={handleCardInput}
                              value={cardInput.expiry_date}
                            />
                            <span className="text-danger">
                              {errorList.expiry_date}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-4 d-flex justify-content-end">
                      <button
                        className="btn btn-warning fw-bold mx-3"
                        onClick={cardInfoSubmit}
                      >
                        <img src={Icon} alt="" className="mx-2 " height={18} />{" "}
                        Apply
                      </button>
                

                      <button className="btn btn-secondary " onClick={dismiss}>
                        <img src={Del} alt="" className="mx-2 " height={18} />{" "}
                        Dismiss Process
                      </button>
                    </div>
                  </form>
 */}
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div>
                {sideData &&
                  sideData?.map((product) => (
                    <RightSideAuction data={product} />
                  ))}
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuctionSignature;
